exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.total-count[data-v-69f8f4ec] { margin-bottom: 12px;\n}\n.filters[data-v-69f8f4ec]     { margin-bottom: 12px;\n}\n.c-file[data-v-69f8f4ec]      { margin-top: 12px;\n}\n.submit-form-container[data-v-69f8f4ec] { margin-top: 12px;\n}\n.submit-button[data-v-69f8f4ec] { margin-top: 12px; color: #fff; background: #25d366; width: 180px; border: none;\n}\n", ""]);

// exports
